import { Dialog, DialogTitle, DialogBackdrop, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../translations/translationsConstants";

export default function LoadingModal({ open, title }) {
    const { t: te } = useTranslation([resources.edit]);
    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog
                as="div"
                className="tailwind-preflight"
                open={open}
                onClose={() => {}} // Prevent closing during loading
            >
                <div className="tw-fixed tw-z-10 tw-inset-0 tw-overflow-y-auto">
                    <div className="tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-pt-4 tw-px-4 tw-pb-20 tw-text-center sm:tw-block sm:tw-p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="tw-ease-out tw-duration-300"
                            enterFrom="tw-opacity-0"
                            enterTo="tw-opacity-100"
                            leave="tw-ease-in tw-duration-200"
                            leaveFrom="tw-opacity-100"
                            leaveTo="tw-opacity-0"
                        >
                            <DialogBackdrop className="tw-fixed tw-inset-0 tw-bg-gray-500 tw-bg-opacity-75 tw-transition-opacity" />
                        </Transition.Child>

                        <span className="tw-hidden sm:tw-inline-block sm:tw-align-middle sm:tw-h-screen" aria-hidden="true">
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="tw-ease-out tw-duration-300"
                            enterFrom="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
                            enterTo="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
                            leave="tw-ease-in tw-duration-200"
                            leaveFrom="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
                            leaveTo="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
                        >
                            <div className="tw-inline-block tw-align-bottom tw-bg-white tw-rounded-lg tw-px-6 tw-pt-8 tw-pb-8 tw-text-left tw-overflow-hidden tw-shadow-xl tw-transform tw-transition-all sm:tw-my-8 sm:tw-align-middle sm:tw-max-w-sm sm:tw-w-full">
                                <div className="tw-text-center">
                                    <div className="tw-mx-auto tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-blue-100 tw-mb-4">
                                        <div className="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-b-2 tw-border-blue-600"></div>
                                    </div>
                                    <DialogTitle as="h3" className="tw-text-lg tw-leading-6 tw-font-medium tw-text-gray-900 tw-mb-2">
                                        {title || te(translations.edit.distribution.generatingPdf)}
                                    </DialogTitle>
                                    <p className="tw-text-sm tw-text-gray-500">
                                        {te(translations.edit.distribution.pleaseWaitProcessing)}
                                    </p>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}